<template>
	<div id="pageRoot">

		<p class="textBase appearAnimationB" id="text01" style="z-index: 6">
			Para realizar esta actividad, vuelve a leer el cuento "Venancio vuela bajito".
		</p>

		<div class="text-box-a hover-animation-a" id="textBox01">
			<p class="textBase" id="textBox01Text">
				Completa los enunciados<br>
				con estas expresiones.
			</p>
		</div>

		<div class="basicItem01" id="tag01">
			<p class="textBase tagText">
				de la heladera.
			</p>
		</div>
		<div class="basicItem01" id="tag02">
			<p class="textBase tagText">
				una silla.
			</p>
		</div>


		<p class="textBase appearAnimationB" id="text02" style="z-index: 6">
			Venancio aprendió a volar con la ayuda de don Fito.
		</p>
		<p class="textBase appearAnimationB" id="text03" style="z-index: 6">
			Primero aprendió a saltar del suelo hasta
		</p>
		<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=1 id="inputField01" class="pageElement" style=
		"z-index: 7"/>

		<p class="textBase appearAnimationB" id="text04" style="z-index: 6">
			Luego del suelo al techo
		</p>
		<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=2 id="inputField02" class="pageElement" style=
		"z-index: 7"/>

		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		<img id="fixed" src="/pages/img/sordo/svgPage81Fixed.svg">
		<span class="footer-page footer-write"></span>
		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
	</div>
</template>
<style scoped>
.tagText
{
position: absolute;
left: 0px;
right: 0px;
top: 5px;
bottom: 0px;

font-size: 36px;
line-height: 49px;
text-align: center;

color: #FEFAFA;
}
#fixed
{
position: absolute;
width: 870.02px;
height: 575px;
left: 41px;
top: 32px;
}
#text01
{
position: absolute;
width: 944px;
height: 35px;
left: 88px;
top: 113px;
}
#text02
{
position: absolute;
width: 594px;
height: 35px;
left: 44px;
top: 434px;
}
#text03
{
position: absolute;
width: 594px;
height: 35px;
left: 38px;
top: 508px;
}
#text04
{
position: absolute;
width: 594px;
height: 35px;
left: 44px;
top: 584px;
}
#textBox01
{
position: absolute;
width: 382.95px;
height: 278.93px;
left: 641.14px;
top: 270px;
background-image: url(/pages/img/sordo/svgPage81Textbox01.svg);
}
#textBox01Text
{
position: absolute;
width: 327px;
height: 75px;
left: 24.86px;
top: 32.25px;

font-size: 26px;
line-height: 35px;
text-align: center;

color: #FBF8F8;
}
#inputField01
{
position: absolute;
width: 352px;
height: 44px;
left: 512px;
top: 482px;
font-size: 33px;
}
#inputField02
{
position: absolute;
width: 540px;
height: 44px;
left: 324px;
top: 558px;
font-size: 33px;
}
#tag01
{
position: absolute;
width: 338px;
height: 70.55px;
left: 132px;
top: 230px;
z-index: 3;
background-image: url(/pages/img/sordo/svgPage75TagMedium.svg);
background-size: contain;
background-repeat: no-repeat;
}
#tag02
{
position: absolute;
width: 204px;
height: 70.55px;
left: 180px;
top: 340px;
z-index: 3;
background-image: url(/pages/img/sordo/svgPage71TagShort.svg);
background-size: contain;
background-repeat: no-repeat;
}

#tag03
{
position: absolute;
width: 335px;
height: 70.55px;
left: 652px;
top: 181px;
z-index: 3;
background-image: url(/pages/img/sordo/svgPage75TagMedium.svg);
background-size: cover;
background-repeat: no-repeat;
}
#tag04
{
position: absolute;
width: 434px;
height: 70.55px;
left: 124px;
top: 283px;
z-index: 3;
background-image: url(/pages/img/sordo/svgPage71TagLong.svg);
background-size: cover;
background-repeat: no-repeat;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p81-82/V91.mp4", "p81-82/V92.mp4", "p81-82/V93.mp4", "p81-82/V96.mp4", 
      "p81/V97.mp4", "p81/V98.mp4", "p81/V99.mp4"]
    }
  }
}
</script>